import { createSelector } from 'reselect';
export const getHubUsers = state => state.entities.hubUsers;
export const getHubUsersAsOptions = createSelector([getHubUsers], hubUsers => hubUsers.reduce((acc, hubUser) => {
  const name = `${hubUser.firstName || ''} ${hubUser.lastName || ''}`.trim();
  acc.push(Object.assign({}, hubUser.toJS(), {
    value: hubUser.email,
    text: `${name} (${hubUser.email})`.trim()
  }));
  return acc;
}, []));